import { gql } from '@apollo/client';

export const CHECK_MAINTENANCE = gql`
  query checkMaintenance($input: String) {
    checkMaintenance(input: $input) {
      status
    }
  }
`;
